unit View.Logs_Sistema.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewLogs_SistemaEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbusuario_id: TLabel;
    edusuario_id: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbtabela: TLabel;
    edtabela: TDBEdit;
    lbservidor: TLabel;
    edservidor: TDBEdit;
    lboperacao: TLabel;
    edoperacao: TDBEdit;
    lblog: TLabel;
    edlog: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbaliado: TLabel;
    cbaliado: TComboBox;
    lbusuario: TLabel;
    cbusuario: TComboBox;
    XDataClientLogs_SistemaGet: TXDataWebClient;
    XDataClientLogs_SistemaDelete: TXDataWebClient;
    Logs_SistemaDataset: TXDataWebDataSet;
    Logs_SistemaDatasetid: TIntegerField;
    Logs_SistemaDatasetusuario_id: TIntegerField;
    Logs_SistemaDatasetaliado_id: TIntegerField;
    Logs_SistemaDatasettabela: TStringField;
    Logs_SistemaDatasetservidor: TIntegerField;
    Logs_SistemaDatasetoperacao: TStringField;
    Logs_SistemaDatasetlog: TStringField;
    Logs_SistemaDatasetinclusao: TDateTimeField;
    Logs_SistemaDatasetaliado: TXDataWebEntityField;
    Logs_SistemaDatasetusuario: TXDataWebEntityField;
    aliadoDataset: TXDataWebDataSet;
    aliadoDatasetId: TIntegerField;
    aliadoDatasetRazao_Social: TStringField;
    aliadoDatasetNome_Fantasia: TStringField;
    aliadoDatasetCNPJ: TStringField;
    aliadoDatasetCodigo_Interno: TIntegerField;
    aliadoDatasetStatus: TIntegerField;
    aliadoDatasetSegmento_ID: TIntegerField;
    aliadoDatasetTelefone_Principal: TStringField;
    aliadoDatasetCEP: TStringField;
    aliadoDatasetEndereco: TStringField;
    aliadoDatasetEndereco_Numero: TStringField;
    aliadoDatasetBairro: TStringField;
    aliadoDatasetCidade_ID: TIntegerField;
    aliadoDatasetComplemento_Endereco: TStringField;
    aliadoDatasetMRR: TFloatField;
    aliadoDatasetregime_contabil: TStringField;
    aliadoDatasetcontador_id: TIntegerField;
    aliadoDatasetsincronizar_dados: TBooleanField;
    aliadoDatasetcontrole_interno: TStringField;
    aliadoDatasetparceiro_id: TIntegerField;
    aliadoDatasetobservacoes: TStringField;
    aliadoDatasetExcluido: TBooleanField;
    aliadoDatasetInclusao: TDateTimeField;
    aliadoDatasetAlteracao: TDateTimeField;
    aliadoDatasetExclusao: TDateTimeField;
    aliadoDatasetCadastro: TDateField;
    aliadoDatasetemail_principal: TStringField;
    aliadoDatasetsegmento: TXDataWebEntityField;
    aliadoDatasetcidade: TXDataWebEntityField;
    aliadoDatasetparceiro: TXDataWebEntityField;
    usuarioDataset: TXDataWebDataSet;
    usuarioDatasetid: TIntegerField;
    usuarioDatasetaliado_id: TIntegerField;
    usuarioDatasetparceiro_id: TIntegerField;
    usuarioDatasetperfil: TIntegerField;
    usuarioDatasetperfil_acesso: TStringField;
    usuarioDatasetdata_base_id: TIntegerField;
    usuarioDatasetnome: TStringField;
    usuarioDatasetemail: TStringField;
    usuarioDatasetsenha: TStringField;
    usuarioDatasetstatus: TIntegerField;
    usuarioDatasetultimo_acesso: TDateTimeField;
    usuarioDatasetinclusao: TDateTimeField;
    usuarioDatasetalteracao: TDateTimeField;
    usuarioDatasetaliado: TXDataWebEntityField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientLogs_SistemaGetLoad(Response: TXDataClientResponse);
    procedure XDataClientLogs_SistemaDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientLogs_SistemaDeleteError(Error: TXDataClientError);
    procedure Logs_SistemaDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
    procedure aliadoDatasetAfterOpen(DataSet: TDataSet);
    procedure usuarioDatasetAfterOpen(DataSet: TDataSet);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewLogs_SistemaEdit: TFViewLogs_SistemaEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewLogs_SistemaEdit }

procedure TFViewLogs_SistemaEdit.btSaveClick(Sender: TObject);
begin
  if Logs_SistemaDataset.State in dsEditModes then
  begin
        Logs_SistemaDatasetaliado.Value := cbaliado.Items.Objects[cbaliado.ItemIndex];
    Logs_SistemaDatasetusuario.Value := cbusuario.Items.Objects[cbusuario.ItemIndex];
    Logs_SistemaDataset.Post;
    Logs_SistemaDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewLogs_SistemaEdit.btDeleteClick(Sender: TObject);
begin
  if Logs_SistemaDataset.State in dsEditModes then
    Logs_SistemaDataset.Post;
  XDataClientLogs_SistemaDelete.Delete(Logs_SistemaDataset.EntitySetName,
    TJSObject(Logs_SistemaDataset.CurrentData));
end;


class function TFViewLogs_SistemaEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewLogs_SistemaEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewLogs_SistemaEdit.InsertEntity;
begin
  Logs_SistemaDataset.Close;
  Logs_SistemaDataset.SetJsonData('{}');
  Logs_SistemaDataset.Open;
  Logs_SistemaDataset.Insert;
  TCrudUtils.LoadAssociationDataset(aliadoDataset, 'Razao_Social');
  TCrudUtils.LoadAssociationDataset(usuarioDataset, 'parceiro_id');
end;

class function TFViewLogs_SistemaEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewLogs_SistemaEdit(AForm).FInserting := AInserting;
    TFViewLogs_SistemaEdit(AForm).FId := AId;
    TFViewLogs_SistemaEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewLogs_SistemaEdit(AForm).InsertEntity
    else
      TFViewLogs_SistemaEdit(AForm).LoadEntity;
    TFViewLogs_SistemaEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewLogs_SistemaEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewLogs_SistemaEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Logs_SistemaDataset.Connection.Model.DefaultSchema.FindEntityType(
      Logs_SistemaDataset.EntitySetName
    )
  );
  XDataClientLogs_SistemaGet.Get(Logs_SistemaDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewLogs_SistemaEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewLogs_SistemaEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewLogs_SistemaEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewLogs_SistemaEdit.XDataClientLogs_SistemaGetLoad(Response: TXDataClientResponse);
begin
  Logs_SistemaDataset.Close;
  Logs_SistemaDataset.SetJsonData(Response.Result);
  Logs_SistemaDataset.Open;
  
  Logs_SistemaDataset.Edit;  
  TCrudUtils.LoadAssociationDataset(aliadoDataset, 'Razao_Social');
  TCrudUtils.LoadAssociationDataset(usuarioDataset, 'parceiro_id');
end;

procedure TFViewLogs_SistemaEdit.XDataClientLogs_SistemaDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewLogs_SistemaEdit.XDataClientLogs_SistemaDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewLogs_SistemaEdit.Logs_SistemaDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewLogs_SistemaEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewLogs_SistemaEdit.aliadoDatasetAfterOpen(DataSet: TDataSet);
begin
  TCrudUtils.PopulateAssociationCombobox(cbaliado,
    TXDataWebDataSet(DataSet), 'Razao_Social');

  if FInserting then
    cbaliado.ItemIndex := -1
  else
  begin
    TCrudUtils.SelectAssociationItem(cbaliado, Logs_SistemaDatasetaliado);
  end;
end;

procedure TFViewLogs_SistemaEdit.usuarioDatasetAfterOpen(DataSet: TDataSet);
begin
  TCrudUtils.PopulateAssociationCombobox(cbusuario,
    TXDataWebDataSet(DataSet), 'parceiro_id');

  if FInserting then
    cbusuario.ItemIndex := -1
  else
  begin
    TCrudUtils.SelectAssociationItem(cbusuario, Logs_SistemaDatasetusuario);
  end;
end;

procedure TFViewLogs_SistemaEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.logs_sistema.form.message');
  lbMessage := TLabel.Create('view.logs_sistema.form.message.label');
  btCloseMessage := TButton.Create('view.logs_sistema.form.message.button');
  btCancel := TButton.Create('view.logs_sistema.form.btBack');
  btSave := TButton.Create('view.logs_sistema.form.btSave');
  btDelete := TButton.Create('view.logs_sistema.form.btDelete');
  lbid := TLabel.Create('view.logs_sistema.form.lbid');
  edid := TDBEdit.Create('view.logs_sistema.form.edid');
  lbusuario_id := TLabel.Create('view.logs_sistema.form.lbusuario_id');
  edusuario_id := TDBEdit.Create('view.logs_sistema.form.edusuario_id');
  lbaliado_id := TLabel.Create('view.logs_sistema.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.logs_sistema.form.edaliado_id');
  lbtabela := TLabel.Create('view.logs_sistema.form.lbtabela');
  edtabela := TDBEdit.Create('view.logs_sistema.form.edtabela');
  lbservidor := TLabel.Create('view.logs_sistema.form.lbservidor');
  edservidor := TDBEdit.Create('view.logs_sistema.form.edservidor');
  lboperacao := TLabel.Create('view.logs_sistema.form.lboperacao');
  edoperacao := TDBEdit.Create('view.logs_sistema.form.edoperacao');
  lblog := TLabel.Create('view.logs_sistema.form.lblog');
  edlog := TDBEdit.Create('view.logs_sistema.form.edlog');
  lbinclusao := TLabel.Create('view.logs_sistema.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.logs_sistema.form.edinclusao');
  lbaliado := TLabel.Create('view.logs_sistema.form.lbaliado');
  cbaliado := TComboBox.Create('view.logs_sistema.form.cbaliado');
  lbusuario := TLabel.Create('view.logs_sistema.form.lbusuario');
  cbusuario := TComboBox.Create('view.logs_sistema.form.cbusuario');
  DataSource := TDataSource.Create(Self);
  Logs_SistemaDataset := TXDataWebDataSet.Create(Self);
  Logs_SistemaDatasetid := TIntegerField.Create(Self);
  Logs_SistemaDatasetusuario_id := TIntegerField.Create(Self);
  Logs_SistemaDatasetaliado_id := TIntegerField.Create(Self);
  Logs_SistemaDatasettabela := TStringField.Create(Self);
  Logs_SistemaDatasetservidor := TIntegerField.Create(Self);
  Logs_SistemaDatasetoperacao := TStringField.Create(Self);
  Logs_SistemaDatasetlog := TStringField.Create(Self);
  Logs_SistemaDatasetinclusao := TDateTimeField.Create(Self);
  Logs_SistemaDatasetaliado := TXDataWebEntityField.Create(Self);
  Logs_SistemaDatasetusuario := TXDataWebEntityField.Create(Self);
  aliadoDataset := TXDataWebDataSet.Create(Self);
  aliadoDatasetId := TIntegerField.Create(Self);
  aliadoDatasetRazao_Social := TStringField.Create(Self);
  aliadoDatasetNome_Fantasia := TStringField.Create(Self);
  aliadoDatasetCNPJ := TStringField.Create(Self);
  aliadoDatasetCodigo_Interno := TIntegerField.Create(Self);
  aliadoDatasetStatus := TIntegerField.Create(Self);
  aliadoDatasetSegmento_ID := TIntegerField.Create(Self);
  aliadoDatasetTelefone_Principal := TStringField.Create(Self);
  aliadoDatasetCEP := TStringField.Create(Self);
  aliadoDatasetEndereco := TStringField.Create(Self);
  aliadoDatasetEndereco_Numero := TStringField.Create(Self);
  aliadoDatasetBairro := TStringField.Create(Self);
  aliadoDatasetCidade_ID := TIntegerField.Create(Self);
  aliadoDatasetComplemento_Endereco := TStringField.Create(Self);
  aliadoDatasetMRR := TFloatField.Create(Self);
  aliadoDatasetregime_contabil := TStringField.Create(Self);
  aliadoDatasetcontador_id := TIntegerField.Create(Self);
  aliadoDatasetsincronizar_dados := TBooleanField.Create(Self);
  aliadoDatasetcontrole_interno := TStringField.Create(Self);
  aliadoDatasetparceiro_id := TIntegerField.Create(Self);
  aliadoDatasetobservacoes := TStringField.Create(Self);
  aliadoDatasetExcluido := TBooleanField.Create(Self);
  aliadoDatasetInclusao := TDateTimeField.Create(Self);
  aliadoDatasetAlteracao := TDateTimeField.Create(Self);
  aliadoDatasetExclusao := TDateTimeField.Create(Self);
  aliadoDatasetCadastro := TDateField.Create(Self);
  aliadoDatasetemail_principal := TStringField.Create(Self);
  aliadoDatasetsegmento := TXDataWebEntityField.Create(Self);
  aliadoDatasetcidade := TXDataWebEntityField.Create(Self);
  aliadoDatasetparceiro := TXDataWebEntityField.Create(Self);
  usuarioDataset := TXDataWebDataSet.Create(Self);
  usuarioDatasetid := TIntegerField.Create(Self);
  usuarioDatasetaliado_id := TIntegerField.Create(Self);
  usuarioDatasetparceiro_id := TIntegerField.Create(Self);
  usuarioDatasetperfil := TIntegerField.Create(Self);
  usuarioDatasetperfil_acesso := TStringField.Create(Self);
  usuarioDatasetdata_base_id := TIntegerField.Create(Self);
  usuarioDatasetnome := TStringField.Create(Self);
  usuarioDatasetemail := TStringField.Create(Self);
  usuarioDatasetsenha := TStringField.Create(Self);
  usuarioDatasetstatus := TIntegerField.Create(Self);
  usuarioDatasetultimo_acesso := TDateTimeField.Create(Self);
  usuarioDatasetinclusao := TDateTimeField.Create(Self);
  usuarioDatasetalteracao := TDateTimeField.Create(Self);
  usuarioDatasetaliado := TXDataWebEntityField.Create(Self);
  XDataClientLogs_SistemaGet := TXDataWebClient.Create(Self);
  XDataClientLogs_SistemaDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbusuario_id.BeforeLoadDFMValues;
  edusuario_id.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbtabela.BeforeLoadDFMValues;
  edtabela.BeforeLoadDFMValues;
  lbservidor.BeforeLoadDFMValues;
  edservidor.BeforeLoadDFMValues;
  lboperacao.BeforeLoadDFMValues;
  edoperacao.BeforeLoadDFMValues;
  lblog.BeforeLoadDFMValues;
  edlog.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbaliado.BeforeLoadDFMValues;
  cbaliado.BeforeLoadDFMValues;
  lbusuario.BeforeLoadDFMValues;
  cbusuario.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Logs_SistemaDataset.BeforeLoadDFMValues;
  Logs_SistemaDatasetid.BeforeLoadDFMValues;
  Logs_SistemaDatasetusuario_id.BeforeLoadDFMValues;
  Logs_SistemaDatasetaliado_id.BeforeLoadDFMValues;
  Logs_SistemaDatasettabela.BeforeLoadDFMValues;
  Logs_SistemaDatasetservidor.BeforeLoadDFMValues;
  Logs_SistemaDatasetoperacao.BeforeLoadDFMValues;
  Logs_SistemaDatasetlog.BeforeLoadDFMValues;
  Logs_SistemaDatasetinclusao.BeforeLoadDFMValues;
  Logs_SistemaDatasetaliado.BeforeLoadDFMValues;
  Logs_SistemaDatasetusuario.BeforeLoadDFMValues;
  aliadoDataset.BeforeLoadDFMValues;
  aliadoDatasetId.BeforeLoadDFMValues;
  aliadoDatasetRazao_Social.BeforeLoadDFMValues;
  aliadoDatasetNome_Fantasia.BeforeLoadDFMValues;
  aliadoDatasetCNPJ.BeforeLoadDFMValues;
  aliadoDatasetCodigo_Interno.BeforeLoadDFMValues;
  aliadoDatasetStatus.BeforeLoadDFMValues;
  aliadoDatasetSegmento_ID.BeforeLoadDFMValues;
  aliadoDatasetTelefone_Principal.BeforeLoadDFMValues;
  aliadoDatasetCEP.BeforeLoadDFMValues;
  aliadoDatasetEndereco.BeforeLoadDFMValues;
  aliadoDatasetEndereco_Numero.BeforeLoadDFMValues;
  aliadoDatasetBairro.BeforeLoadDFMValues;
  aliadoDatasetCidade_ID.BeforeLoadDFMValues;
  aliadoDatasetComplemento_Endereco.BeforeLoadDFMValues;
  aliadoDatasetMRR.BeforeLoadDFMValues;
  aliadoDatasetregime_contabil.BeforeLoadDFMValues;
  aliadoDatasetcontador_id.BeforeLoadDFMValues;
  aliadoDatasetsincronizar_dados.BeforeLoadDFMValues;
  aliadoDatasetcontrole_interno.BeforeLoadDFMValues;
  aliadoDatasetparceiro_id.BeforeLoadDFMValues;
  aliadoDatasetobservacoes.BeforeLoadDFMValues;
  aliadoDatasetExcluido.BeforeLoadDFMValues;
  aliadoDatasetInclusao.BeforeLoadDFMValues;
  aliadoDatasetAlteracao.BeforeLoadDFMValues;
  aliadoDatasetExclusao.BeforeLoadDFMValues;
  aliadoDatasetCadastro.BeforeLoadDFMValues;
  aliadoDatasetemail_principal.BeforeLoadDFMValues;
  aliadoDatasetsegmento.BeforeLoadDFMValues;
  aliadoDatasetcidade.BeforeLoadDFMValues;
  aliadoDatasetparceiro.BeforeLoadDFMValues;
  usuarioDataset.BeforeLoadDFMValues;
  usuarioDatasetid.BeforeLoadDFMValues;
  usuarioDatasetaliado_id.BeforeLoadDFMValues;
  usuarioDatasetparceiro_id.BeforeLoadDFMValues;
  usuarioDatasetperfil.BeforeLoadDFMValues;
  usuarioDatasetperfil_acesso.BeforeLoadDFMValues;
  usuarioDatasetdata_base_id.BeforeLoadDFMValues;
  usuarioDatasetnome.BeforeLoadDFMValues;
  usuarioDatasetemail.BeforeLoadDFMValues;
  usuarioDatasetsenha.BeforeLoadDFMValues;
  usuarioDatasetstatus.BeforeLoadDFMValues;
  usuarioDatasetultimo_acesso.BeforeLoadDFMValues;
  usuarioDatasetinclusao.BeforeLoadDFMValues;
  usuarioDatasetalteracao.BeforeLoadDFMValues;
  usuarioDatasetaliado.BeforeLoadDFMValues;
  XDataClientLogs_SistemaGet.BeforeLoadDFMValues;
  XDataClientLogs_SistemaDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewLogs_SistemaEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 535;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 475;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 475;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 475;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbusuario_id.SetParentComponent(Self);
    lbusuario_id.Name := 'lbusuario_id';
    lbusuario_id.Left := 24;
    lbusuario_id.Top := 219;
    lbusuario_id.Width := 14;
    lbusuario_id.Height := 13;
    lbusuario_id.Caption := 'usuario_id:';
    lbusuario_id.Transparent := True;
    edusuario_id.SetParentComponent(Self);
    edusuario_id.Name := 'edusuario_id';
    edusuario_id.Left := 221;
    edusuario_id.Top := 216;
    edusuario_id.Width := 200;
    edusuario_id.Height := 21;
    edusuario_id.Enabled := True;
    edusuario_id.TabOrder := 7;
    edusuario_id.Text := 'edusuario_id';
    edusuario_id.DataField := 'usuario_id';
    edusuario_id.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 246;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 243;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 8;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbtabela.SetParentComponent(Self);
    lbtabela.Name := 'lbtabela';
    lbtabela.Left := 24;
    lbtabela.Top := 273;
    lbtabela.Width := 14;
    lbtabela.Height := 13;
    lbtabela.Caption := 'tabela:';
    lbtabela.Transparent := True;
    edtabela.SetParentComponent(Self);
    edtabela.Name := 'edtabela';
    edtabela.Left := 221;
    edtabela.Top := 270;
    edtabela.Width := 200;
    edtabela.Height := 21;
    edtabela.Enabled := True;
    edtabela.TabOrder := 9;
    edtabela.Text := 'edtabela';
    edtabela.DataField := 'tabela';
    edtabela.DataSource := DataSource;
    lbservidor.SetParentComponent(Self);
    lbservidor.Name := 'lbservidor';
    lbservidor.Left := 24;
    lbservidor.Top := 300;
    lbservidor.Width := 14;
    lbservidor.Height := 13;
    lbservidor.Caption := 'servidor:';
    lbservidor.Transparent := True;
    edservidor.SetParentComponent(Self);
    edservidor.Name := 'edservidor';
    edservidor.Left := 221;
    edservidor.Top := 297;
    edservidor.Width := 200;
    edservidor.Height := 21;
    edservidor.Enabled := True;
    edservidor.TabOrder := 10;
    edservidor.Text := 'edservidor';
    edservidor.DataField := 'servidor';
    edservidor.DataSource := DataSource;
    lboperacao.SetParentComponent(Self);
    lboperacao.Name := 'lboperacao';
    lboperacao.Left := 24;
    lboperacao.Top := 327;
    lboperacao.Width := 14;
    lboperacao.Height := 13;
    lboperacao.Caption := 'operacao:';
    lboperacao.Transparent := True;
    edoperacao.SetParentComponent(Self);
    edoperacao.Name := 'edoperacao';
    edoperacao.Left := 221;
    edoperacao.Top := 324;
    edoperacao.Width := 200;
    edoperacao.Height := 21;
    edoperacao.Enabled := True;
    edoperacao.TabOrder := 11;
    edoperacao.Text := 'edoperacao';
    edoperacao.DataField := 'operacao';
    edoperacao.DataSource := DataSource;
    lblog.SetParentComponent(Self);
    lblog.Name := 'lblog';
    lblog.Left := 24;
    lblog.Top := 354;
    lblog.Width := 14;
    lblog.Height := 13;
    lblog.Caption := 'log:';
    lblog.Transparent := True;
    edlog.SetParentComponent(Self);
    edlog.Name := 'edlog';
    edlog.Left := 221;
    edlog.Top := 351;
    edlog.Width := 200;
    edlog.Height := 21;
    edlog.Enabled := True;
    edlog.TabOrder := 12;
    edlog.Text := 'edlog';
    edlog.DataField := 'log';
    edlog.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 381;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 378;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 13;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbaliado.SetParentComponent(Self);
    lbaliado.Name := 'lbaliado';
    lbaliado.Left := 24;
    lbaliado.Top := 408;
    lbaliado.Width := 14;
    lbaliado.Height := 13;
    lbaliado.Caption := 'aliado:';
    lbaliado.Transparent := True;
    cbaliado.SetParentComponent(Self);
    cbaliado.Name := 'cbaliado';
    cbaliado.Left := 221;
    cbaliado.Top := 405;
    cbaliado.Width := 200;
    cbaliado.Height := 21;
    cbaliado.ItemIndex := -1;
    cbaliado.TabOrder := 14;
    cbaliado.Text := 'cbaliado';
    lbusuario.SetParentComponent(Self);
    lbusuario.Name := 'lbusuario';
    lbusuario.Left := 24;
    lbusuario.Top := 435;
    lbusuario.Width := 14;
    lbusuario.Height := 13;
    lbusuario.Caption := 'usuario:';
    lbusuario.Transparent := True;
    cbusuario.SetParentComponent(Self);
    cbusuario.Name := 'cbusuario';
    cbusuario.Left := 221;
    cbusuario.Top := 432;
    cbusuario.Width := 200;
    cbusuario.Height := 21;
    cbusuario.ItemIndex := -1;
    cbusuario.TabOrder := 15;
    cbusuario.Text := 'cbusuario';
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Logs_SistemaDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Logs_SistemaDataset.SetParentComponent(Self);
    Logs_SistemaDataset.Name := 'Logs_SistemaDataset';
    Logs_SistemaDataset.AfterApplyUpdates := Logs_SistemaDatasetAfterApplyUpdates;
    Logs_SistemaDataset.EntitySetName := 'Logs_Sistema';
    Logs_SistemaDataset.Connection := DMConnection.ApiConnection;
    Logs_SistemaDataset.Left := 176;
    Logs_SistemaDataset.Top := 8;
    Logs_SistemaDatasetid.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetid.Name := 'Logs_SistemaDatasetid';
    Logs_SistemaDatasetid.FieldName := 'id';
    Logs_SistemaDatasetid.Required := True;
    Logs_SistemaDatasetusuario_id.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetusuario_id.Name := 'Logs_SistemaDatasetusuario_id';
    Logs_SistemaDatasetusuario_id.FieldName := 'usuario_id';
    Logs_SistemaDatasetusuario_id.Required := True;
    Logs_SistemaDatasetaliado_id.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetaliado_id.Name := 'Logs_SistemaDatasetaliado_id';
    Logs_SistemaDatasetaliado_id.FieldName := 'aliado_id';
    Logs_SistemaDatasetaliado_id.Required := False;
    Logs_SistemaDatasettabela.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasettabela.Name := 'Logs_SistemaDatasettabela';
    Logs_SistemaDatasettabela.FieldName := 'tabela';
    Logs_SistemaDatasettabela.Required := True;
    Logs_SistemaDatasettabela.Size := 255;
    Logs_SistemaDatasetservidor.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetservidor.Name := 'Logs_SistemaDatasetservidor';
    Logs_SistemaDatasetservidor.FieldName := 'servidor';
    Logs_SistemaDatasetservidor.Required := True;
    Logs_SistemaDatasetoperacao.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetoperacao.Name := 'Logs_SistemaDatasetoperacao';
    Logs_SistemaDatasetoperacao.FieldName := 'operacao';
    Logs_SistemaDatasetoperacao.Required := True;
    Logs_SistemaDatasetoperacao.Size := 255;
    Logs_SistemaDatasetlog.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetlog.Name := 'Logs_SistemaDatasetlog';
    Logs_SistemaDatasetlog.FieldName := 'log';
    Logs_SistemaDatasetlog.Required := True;
    Logs_SistemaDatasetlog.Size := 255;
    Logs_SistemaDatasetinclusao.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetinclusao.Name := 'Logs_SistemaDatasetinclusao';
    Logs_SistemaDatasetinclusao.FieldName := 'inclusao';
    Logs_SistemaDatasetinclusao.Required := False;
    Logs_SistemaDatasetaliado.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetaliado.Name := 'Logs_SistemaDatasetaliado';
    Logs_SistemaDatasetaliado.FieldName := 'aliado';
    Logs_SistemaDatasetaliado.Required := False;
    Logs_SistemaDatasetusuario.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetusuario.Name := 'Logs_SistemaDatasetusuario';
    Logs_SistemaDatasetusuario.FieldName := 'usuario';
    Logs_SistemaDatasetusuario.Required := False;
    aliadoDataset.SetParentComponent(Self);
    aliadoDataset.Name := 'aliadoDataset';
    aliadoDataset.AfterOpen := aliadoDatasetAfterOpen;
    aliadoDataset.EntitySetName := 'Aliado';
    aliadoDataset.Connection := DMConnection.ApiConnection;
    aliadoDataset.Left := 284;
    aliadoDataset.Top := 8;
    aliadoDatasetId.SetParentComponent(aliadoDataset);
    aliadoDatasetId.Name := 'aliadoDatasetId';
    aliadoDatasetId.FieldName := 'Id';
    aliadoDatasetId.Required := True;
    aliadoDatasetRazao_Social.SetParentComponent(aliadoDataset);
    aliadoDatasetRazao_Social.Name := 'aliadoDatasetRazao_Social';
    aliadoDatasetRazao_Social.FieldName := 'Razao_Social';
    aliadoDatasetRazao_Social.Required := True;
    aliadoDatasetRazao_Social.Size := 255;
    aliadoDatasetNome_Fantasia.SetParentComponent(aliadoDataset);
    aliadoDatasetNome_Fantasia.Name := 'aliadoDatasetNome_Fantasia';
    aliadoDatasetNome_Fantasia.FieldName := 'Nome_Fantasia';
    aliadoDatasetNome_Fantasia.Required := True;
    aliadoDatasetNome_Fantasia.Size := 255;
    aliadoDatasetCNPJ.SetParentComponent(aliadoDataset);
    aliadoDatasetCNPJ.Name := 'aliadoDatasetCNPJ';
    aliadoDatasetCNPJ.FieldName := 'CNPJ';
    aliadoDatasetCNPJ.Required := True;
    aliadoDatasetCNPJ.Size := 255;
    aliadoDatasetCodigo_Interno.SetParentComponent(aliadoDataset);
    aliadoDatasetCodigo_Interno.Name := 'aliadoDatasetCodigo_Interno';
    aliadoDatasetCodigo_Interno.FieldName := 'Codigo_Interno';
    aliadoDatasetCodigo_Interno.Required := False;
    aliadoDatasetStatus.SetParentComponent(aliadoDataset);
    aliadoDatasetStatus.Name := 'aliadoDatasetStatus';
    aliadoDatasetStatus.FieldName := 'Status';
    aliadoDatasetStatus.Required := True;
    aliadoDatasetSegmento_ID.SetParentComponent(aliadoDataset);
    aliadoDatasetSegmento_ID.Name := 'aliadoDatasetSegmento_ID';
    aliadoDatasetSegmento_ID.FieldName := 'Segmento_ID';
    aliadoDatasetSegmento_ID.Required := False;
    aliadoDatasetTelefone_Principal.SetParentComponent(aliadoDataset);
    aliadoDatasetTelefone_Principal.Name := 'aliadoDatasetTelefone_Principal';
    aliadoDatasetTelefone_Principal.FieldName := 'Telefone_Principal';
    aliadoDatasetTelefone_Principal.Required := False;
    aliadoDatasetTelefone_Principal.Size := 255;
    aliadoDatasetCEP.SetParentComponent(aliadoDataset);
    aliadoDatasetCEP.Name := 'aliadoDatasetCEP';
    aliadoDatasetCEP.FieldName := 'CEP';
    aliadoDatasetCEP.Required := False;
    aliadoDatasetCEP.Size := 255;
    aliadoDatasetEndereco.SetParentComponent(aliadoDataset);
    aliadoDatasetEndereco.Name := 'aliadoDatasetEndereco';
    aliadoDatasetEndereco.FieldName := 'Endereco';
    aliadoDatasetEndereco.Required := False;
    aliadoDatasetEndereco.Size := 255;
    aliadoDatasetEndereco_Numero.SetParentComponent(aliadoDataset);
    aliadoDatasetEndereco_Numero.Name := 'aliadoDatasetEndereco_Numero';
    aliadoDatasetEndereco_Numero.FieldName := 'Endereco_Numero';
    aliadoDatasetEndereco_Numero.Required := False;
    aliadoDatasetEndereco_Numero.Size := 255;
    aliadoDatasetBairro.SetParentComponent(aliadoDataset);
    aliadoDatasetBairro.Name := 'aliadoDatasetBairro';
    aliadoDatasetBairro.FieldName := 'Bairro';
    aliadoDatasetBairro.Required := False;
    aliadoDatasetBairro.Size := 255;
    aliadoDatasetCidade_ID.SetParentComponent(aliadoDataset);
    aliadoDatasetCidade_ID.Name := 'aliadoDatasetCidade_ID';
    aliadoDatasetCidade_ID.FieldName := 'Cidade_ID';
    aliadoDatasetCidade_ID.Required := False;
    aliadoDatasetComplemento_Endereco.SetParentComponent(aliadoDataset);
    aliadoDatasetComplemento_Endereco.Name := 'aliadoDatasetComplemento_Endereco';
    aliadoDatasetComplemento_Endereco.FieldName := 'Complemento_Endereco';
    aliadoDatasetComplemento_Endereco.Required := False;
    aliadoDatasetComplemento_Endereco.Size := 255;
    aliadoDatasetMRR.SetParentComponent(aliadoDataset);
    aliadoDatasetMRR.Name := 'aliadoDatasetMRR';
    aliadoDatasetMRR.FieldName := 'MRR';
    aliadoDatasetMRR.Required := False;
    aliadoDatasetregime_contabil.SetParentComponent(aliadoDataset);
    aliadoDatasetregime_contabil.Name := 'aliadoDatasetregime_contabil';
    aliadoDatasetregime_contabil.FieldName := 'regime_contabil';
    aliadoDatasetregime_contabil.Required := False;
    aliadoDatasetregime_contabil.Size := 255;
    aliadoDatasetcontador_id.SetParentComponent(aliadoDataset);
    aliadoDatasetcontador_id.Name := 'aliadoDatasetcontador_id';
    aliadoDatasetcontador_id.FieldName := 'contador_id';
    aliadoDatasetcontador_id.Required := False;
    aliadoDatasetsincronizar_dados.SetParentComponent(aliadoDataset);
    aliadoDatasetsincronizar_dados.Name := 'aliadoDatasetsincronizar_dados';
    aliadoDatasetsincronizar_dados.FieldName := 'sincronizar_dados';
    aliadoDatasetsincronizar_dados.Required := False;
    aliadoDatasetcontrole_interno.SetParentComponent(aliadoDataset);
    aliadoDatasetcontrole_interno.Name := 'aliadoDatasetcontrole_interno';
    aliadoDatasetcontrole_interno.FieldName := 'controle_interno';
    aliadoDatasetcontrole_interno.Required := False;
    aliadoDatasetcontrole_interno.Size := 255;
    aliadoDatasetparceiro_id.SetParentComponent(aliadoDataset);
    aliadoDatasetparceiro_id.Name := 'aliadoDatasetparceiro_id';
    aliadoDatasetparceiro_id.FieldName := 'parceiro_id';
    aliadoDatasetparceiro_id.Required := False;
    aliadoDatasetobservacoes.SetParentComponent(aliadoDataset);
    aliadoDatasetobservacoes.Name := 'aliadoDatasetobservacoes';
    aliadoDatasetobservacoes.FieldName := 'observacoes';
    aliadoDatasetobservacoes.Required := False;
    aliadoDatasetobservacoes.Size := 255;
    aliadoDatasetExcluido.SetParentComponent(aliadoDataset);
    aliadoDatasetExcluido.Name := 'aliadoDatasetExcluido';
    aliadoDatasetExcluido.FieldName := 'Excluido';
    aliadoDatasetExcluido.Required := True;
    aliadoDatasetInclusao.SetParentComponent(aliadoDataset);
    aliadoDatasetInclusao.Name := 'aliadoDatasetInclusao';
    aliadoDatasetInclusao.FieldName := 'Inclusao';
    aliadoDatasetInclusao.Required := False;
    aliadoDatasetAlteracao.SetParentComponent(aliadoDataset);
    aliadoDatasetAlteracao.Name := 'aliadoDatasetAlteracao';
    aliadoDatasetAlteracao.FieldName := 'Alteracao';
    aliadoDatasetAlteracao.Required := False;
    aliadoDatasetExclusao.SetParentComponent(aliadoDataset);
    aliadoDatasetExclusao.Name := 'aliadoDatasetExclusao';
    aliadoDatasetExclusao.FieldName := 'Exclusao';
    aliadoDatasetExclusao.Required := False;
    aliadoDatasetCadastro.SetParentComponent(aliadoDataset);
    aliadoDatasetCadastro.Name := 'aliadoDatasetCadastro';
    aliadoDatasetCadastro.FieldName := 'Cadastro';
    aliadoDatasetCadastro.Required := False;
    aliadoDatasetemail_principal.SetParentComponent(aliadoDataset);
    aliadoDatasetemail_principal.Name := 'aliadoDatasetemail_principal';
    aliadoDatasetemail_principal.FieldName := 'email_principal';
    aliadoDatasetemail_principal.Required := False;
    aliadoDatasetemail_principal.Size := 255;
    aliadoDatasetsegmento.SetParentComponent(aliadoDataset);
    aliadoDatasetsegmento.Name := 'aliadoDatasetsegmento';
    aliadoDatasetsegmento.FieldName := 'segmento';
    aliadoDatasetsegmento.Required := False;
    aliadoDatasetcidade.SetParentComponent(aliadoDataset);
    aliadoDatasetcidade.Name := 'aliadoDatasetcidade';
    aliadoDatasetcidade.FieldName := 'cidade';
    aliadoDatasetcidade.Required := False;
    aliadoDatasetparceiro.SetParentComponent(aliadoDataset);
    aliadoDatasetparceiro.Name := 'aliadoDatasetparceiro';
    aliadoDatasetparceiro.FieldName := 'parceiro';
    aliadoDatasetparceiro.Required := False;
    usuarioDataset.SetParentComponent(Self);
    usuarioDataset.Name := 'usuarioDataset';
    usuarioDataset.AfterOpen := usuarioDatasetAfterOpen;
    usuarioDataset.EntitySetName := 'Usuarios';
    usuarioDataset.Connection := DMConnection.ApiConnection;
    usuarioDataset.Left := 384;
    usuarioDataset.Top := 8;
    usuarioDatasetid.SetParentComponent(usuarioDataset);
    usuarioDatasetid.Name := 'usuarioDatasetid';
    usuarioDatasetid.FieldName := 'id';
    usuarioDatasetid.Required := True;
    usuarioDatasetaliado_id.SetParentComponent(usuarioDataset);
    usuarioDatasetaliado_id.Name := 'usuarioDatasetaliado_id';
    usuarioDatasetaliado_id.FieldName := 'aliado_id';
    usuarioDatasetaliado_id.Required := False;
    usuarioDatasetparceiro_id.SetParentComponent(usuarioDataset);
    usuarioDatasetparceiro_id.Name := 'usuarioDatasetparceiro_id';
    usuarioDatasetparceiro_id.FieldName := 'parceiro_id';
    usuarioDatasetparceiro_id.Required := True;
    usuarioDatasetperfil.SetParentComponent(usuarioDataset);
    usuarioDatasetperfil.Name := 'usuarioDatasetperfil';
    usuarioDatasetperfil.FieldName := 'perfil';
    usuarioDatasetperfil.Required := True;
    usuarioDatasetperfil_acesso.SetParentComponent(usuarioDataset);
    usuarioDatasetperfil_acesso.Name := 'usuarioDatasetperfil_acesso';
    usuarioDatasetperfil_acesso.FieldName := 'perfil_acesso';
    usuarioDatasetperfil_acesso.Required := False;
    usuarioDatasetperfil_acesso.Size := 255;
    usuarioDatasetdata_base_id.SetParentComponent(usuarioDataset);
    usuarioDatasetdata_base_id.Name := 'usuarioDatasetdata_base_id';
    usuarioDatasetdata_base_id.FieldName := 'data_base_id';
    usuarioDatasetdata_base_id.Required := False;
    usuarioDatasetnome.SetParentComponent(usuarioDataset);
    usuarioDatasetnome.Name := 'usuarioDatasetnome';
    usuarioDatasetnome.FieldName := 'nome';
    usuarioDatasetnome.Required := True;
    usuarioDatasetnome.Size := 255;
    usuarioDatasetemail.SetParentComponent(usuarioDataset);
    usuarioDatasetemail.Name := 'usuarioDatasetemail';
    usuarioDatasetemail.FieldName := 'email';
    usuarioDatasetemail.Required := True;
    usuarioDatasetemail.Size := 255;
    usuarioDatasetsenha.SetParentComponent(usuarioDataset);
    usuarioDatasetsenha.Name := 'usuarioDatasetsenha';
    usuarioDatasetsenha.FieldName := 'senha';
    usuarioDatasetsenha.Required := True;
    usuarioDatasetsenha.Size := 255;
    usuarioDatasetstatus.SetParentComponent(usuarioDataset);
    usuarioDatasetstatus.Name := 'usuarioDatasetstatus';
    usuarioDatasetstatus.FieldName := 'status';
    usuarioDatasetstatus.Required := True;
    usuarioDatasetultimo_acesso.SetParentComponent(usuarioDataset);
    usuarioDatasetultimo_acesso.Name := 'usuarioDatasetultimo_acesso';
    usuarioDatasetultimo_acesso.FieldName := 'ultimo_acesso';
    usuarioDatasetultimo_acesso.Required := False;
    usuarioDatasetinclusao.SetParentComponent(usuarioDataset);
    usuarioDatasetinclusao.Name := 'usuarioDatasetinclusao';
    usuarioDatasetinclusao.FieldName := 'inclusao';
    usuarioDatasetinclusao.Required := False;
    usuarioDatasetalteracao.SetParentComponent(usuarioDataset);
    usuarioDatasetalteracao.Name := 'usuarioDatasetalteracao';
    usuarioDatasetalteracao.FieldName := 'alteracao';
    usuarioDatasetalteracao.Required := False;
    usuarioDatasetaliado.SetParentComponent(usuarioDataset);
    usuarioDatasetaliado.Name := 'usuarioDatasetaliado';
    usuarioDatasetaliado.FieldName := 'aliado';
    usuarioDatasetaliado.Required := False;
    XDataClientLogs_SistemaGet.SetParentComponent(Self);
    XDataClientLogs_SistemaGet.Name := 'XDataClientLogs_SistemaGet';
    XDataClientLogs_SistemaGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientLogs_SistemaGet, Self, 'OnLoad', 'XDataClientLogs_SistemaGetLoad');
    XDataClientLogs_SistemaGet.Left := 64;
    XDataClientLogs_SistemaGet.Top := 8;
    XDataClientLogs_SistemaDelete.SetParentComponent(Self);
    XDataClientLogs_SistemaDelete.Name := 'XDataClientLogs_SistemaDelete';
    XDataClientLogs_SistemaDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientLogs_SistemaDelete, Self, 'OnLoad', 'XDataClientLogs_SistemaDeleteLoad');
    SetEvent(XDataClientLogs_SistemaDelete, Self, 'OnError', 'XDataClientLogs_SistemaDeleteError');
    XDataClientLogs_SistemaDelete.Left := 64;
    XDataClientLogs_SistemaDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbusuario_id.AfterLoadDFMValues;
    edusuario_id.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbtabela.AfterLoadDFMValues;
    edtabela.AfterLoadDFMValues;
    lbservidor.AfterLoadDFMValues;
    edservidor.AfterLoadDFMValues;
    lboperacao.AfterLoadDFMValues;
    edoperacao.AfterLoadDFMValues;
    lblog.AfterLoadDFMValues;
    edlog.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbaliado.AfterLoadDFMValues;
    cbaliado.AfterLoadDFMValues;
    lbusuario.AfterLoadDFMValues;
    cbusuario.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Logs_SistemaDataset.AfterLoadDFMValues;
    Logs_SistemaDatasetid.AfterLoadDFMValues;
    Logs_SistemaDatasetusuario_id.AfterLoadDFMValues;
    Logs_SistemaDatasetaliado_id.AfterLoadDFMValues;
    Logs_SistemaDatasettabela.AfterLoadDFMValues;
    Logs_SistemaDatasetservidor.AfterLoadDFMValues;
    Logs_SistemaDatasetoperacao.AfterLoadDFMValues;
    Logs_SistemaDatasetlog.AfterLoadDFMValues;
    Logs_SistemaDatasetinclusao.AfterLoadDFMValues;
    Logs_SistemaDatasetaliado.AfterLoadDFMValues;
    Logs_SistemaDatasetusuario.AfterLoadDFMValues;
    aliadoDataset.AfterLoadDFMValues;
    aliadoDatasetId.AfterLoadDFMValues;
    aliadoDatasetRazao_Social.AfterLoadDFMValues;
    aliadoDatasetNome_Fantasia.AfterLoadDFMValues;
    aliadoDatasetCNPJ.AfterLoadDFMValues;
    aliadoDatasetCodigo_Interno.AfterLoadDFMValues;
    aliadoDatasetStatus.AfterLoadDFMValues;
    aliadoDatasetSegmento_ID.AfterLoadDFMValues;
    aliadoDatasetTelefone_Principal.AfterLoadDFMValues;
    aliadoDatasetCEP.AfterLoadDFMValues;
    aliadoDatasetEndereco.AfterLoadDFMValues;
    aliadoDatasetEndereco_Numero.AfterLoadDFMValues;
    aliadoDatasetBairro.AfterLoadDFMValues;
    aliadoDatasetCidade_ID.AfterLoadDFMValues;
    aliadoDatasetComplemento_Endereco.AfterLoadDFMValues;
    aliadoDatasetMRR.AfterLoadDFMValues;
    aliadoDatasetregime_contabil.AfterLoadDFMValues;
    aliadoDatasetcontador_id.AfterLoadDFMValues;
    aliadoDatasetsincronizar_dados.AfterLoadDFMValues;
    aliadoDatasetcontrole_interno.AfterLoadDFMValues;
    aliadoDatasetparceiro_id.AfterLoadDFMValues;
    aliadoDatasetobservacoes.AfterLoadDFMValues;
    aliadoDatasetExcluido.AfterLoadDFMValues;
    aliadoDatasetInclusao.AfterLoadDFMValues;
    aliadoDatasetAlteracao.AfterLoadDFMValues;
    aliadoDatasetExclusao.AfterLoadDFMValues;
    aliadoDatasetCadastro.AfterLoadDFMValues;
    aliadoDatasetemail_principal.AfterLoadDFMValues;
    aliadoDatasetsegmento.AfterLoadDFMValues;
    aliadoDatasetcidade.AfterLoadDFMValues;
    aliadoDatasetparceiro.AfterLoadDFMValues;
    usuarioDataset.AfterLoadDFMValues;
    usuarioDatasetid.AfterLoadDFMValues;
    usuarioDatasetaliado_id.AfterLoadDFMValues;
    usuarioDatasetparceiro_id.AfterLoadDFMValues;
    usuarioDatasetperfil.AfterLoadDFMValues;
    usuarioDatasetperfil_acesso.AfterLoadDFMValues;
    usuarioDatasetdata_base_id.AfterLoadDFMValues;
    usuarioDatasetnome.AfterLoadDFMValues;
    usuarioDatasetemail.AfterLoadDFMValues;
    usuarioDatasetsenha.AfterLoadDFMValues;
    usuarioDatasetstatus.AfterLoadDFMValues;
    usuarioDatasetultimo_acesso.AfterLoadDFMValues;
    usuarioDatasetinclusao.AfterLoadDFMValues;
    usuarioDatasetalteracao.AfterLoadDFMValues;
    usuarioDatasetaliado.AfterLoadDFMValues;
    XDataClientLogs_SistemaGet.AfterLoadDFMValues;
    XDataClientLogs_SistemaDelete.AfterLoadDFMValues;
  end;
end;

end.
